// extracted by mini-css-extract-plugin
module.exports = {"theme":"Theme_theme__1aqaz","input":"Theme_input__1Zo2B","inner":"Theme_inner__1G9Lo","box":"Theme_box__4kQtU","themeBig":"Theme_themeBig__qeBkq"};